"use client";

import { useMemo, useState } from "react";

import type { BlogPostListItem } from "@/types";

export function useBlogList(posts: BlogPostListItem[]) {
  const [active, setActive] = useState("All");

  const visiblePosts = useMemo(() => {
    if (active === "All") return posts;
    return posts.filter((p) => p.category?.name === active);
  }, [posts, active]);

  const featured = useMemo(
    () => visiblePosts.find((p) => p.is_featured) ?? visiblePosts[0],
    [visiblePosts],
  );
  const rest = useMemo(
    () => visiblePosts.filter((p) => p.id !== featured?.id),
    [visiblePosts, featured],
  );

  return { active, setActive, visiblePosts, featured, rest };
}
